import { render, staticRenderFns } from "./SjcpXq.vue?vue&type=template&id=d447f2de&scoped=true&"
import script from "./SjcpXq.vue?vue&type=script&lang=js&"
export * from "./SjcpXq.vue?vue&type=script&lang=js&"
import style0 from "./SjcpXq.vue?vue&type=style&index=0&id=d447f2de&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d447f2de",
  null
  
)

export default component.exports